import { BaseEntityDto, UserRole } from '@fleet-beat/core';

export interface HistoryDto extends BaseEntityDto {
  id?: string;
  occasionID?: string;
  occasionName?: string;
  occasionType?: string;
  participant?: {
    image?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    id?: string;
    role: UserRole;
  };
  managerName?: string;
  timestamp?: string;
  ipAddress?: string;
}
